import React, { useState } from "react";

function App() {
  const [activeSection, setActiveSection] = useState("home");

  return (
    <div className="min-h-screen flex flex-col">
      {/* 导航栏 */}
      <header className="bg-blue-600 text-white shadow-md">
        <div className="container mx-auto px-4 py-4 flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center mb-4 md:mb-0">
            <h1 className="text-2xl font-bold">TryOnTry 试衣试</h1>
          </div>
          <nav>
            <ul className="flex flex-wrap gap-6">
              <li>
                <button
                  onClick={() => setActiveSection("home")}
                  className={`transition-colors ${
                    activeSection === "home"
                      ? "text-yellow-300"
                      : "hover:text-yellow-200"
                  }`}
                >
                  首页
                </button>
              </li>
              <li>
                <button
                  onClick={() => setActiveSection("features")}
                  className={`transition-colors ${
                    activeSection === "features"
                      ? "text-yellow-300"
                      : "hover:text-yellow-200"
                  }`}
                >
                  功能特点
                </button>
              </li>
              <li>
                <button
                  onClick={() => setActiveSection("download")}
                  className={`transition-colors ${
                    activeSection === "download"
                      ? "text-yellow-300"
                      : "hover:text-yellow-200"
                  }`}
                >
                  立即下载
                </button>
              </li>
              <li>
                <button
                  onClick={() => setActiveSection("contact")}
                  className={`transition-colors ${
                    activeSection === "contact"
                      ? "text-yellow-300"
                      : "hover:text-yellow-200"
                  }`}
                >
                  联系我们
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      {/* 内容区域 */}
      <main className="flex-grow">
        {activeSection === "home" && (
          <section className="py-12 px-4">
            <div className="container mx-auto">
              <div className="flex flex-col md:flex-row items-center">
                <div className="md:w-1/2 mb-8 md:mb-0">
                  <h2 className="text-3xl font-bold mb-4">
                    AI智能虚拟试衣，革新购物体验
                  </h2>
                  <p className="text-lg mb-6">
                    TryOnTry是一款基于人工智能的虚拟试衣应用，让您足不出户即可体验真实试衣效果。通过先进的3D建模和AI技术，实现个性化虚拟试穿，告别购物退货烦恼。
                  </p>
                  <button
                    onClick={() => setActiveSection("download")}
                    className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    立即下载
                  </button>
                </div>
                <div className="md:w-1/2 flex justify-center">
                  <div className="w-64 h-96 bg-gray-200 rounded-3xl flex items-center justify-center shadow-lg">
                    <img
                      className="w-full h-full object-cover"
                      src="https://s21.ax1x.com/2025/04/05/pE6ohDS.png"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {activeSection === "features" && (
          <section className="py-12 px-4 bg-gray-100">
            <div className="container mx-auto">
              <h2 className="text-3xl font-bold text-center mb-12">功能特点</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <div className="bg-white p-6 rounded-lg shadow-md">
                  <h3 className="text-xl font-bold mb-3">3D模型定制</h3>
                  <p>
                    通过拍照或上传照片，AI技术快速生成您的个人3D模型，精准还原身材特征。
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md">
                  <h3 className="text-xl font-bold mb-3">海量时装库</h3>
                  <p>
                    对接数百家品牌，数万件服装可供试穿，覆盖从日常休闲到正式场合的各类需求。
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md">
                  <h3 className="text-xl font-bold mb-3">微信支付集成</h3>
                  <p>
                    喜欢就直接购买，支持微信一键支付，安全便捷，让购物体验更加流畅。
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md">
                  <h3 className="text-xl font-bold mb-3">真实物理模拟</h3>
                  <p>
                    独创布料物理引擎，精确模拟不同面料的垂坠感、贴合度，提供真实试穿效果。
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md">
                  <h3 className="text-xl font-bold mb-3">搭配推荐</h3>
                  <p>
                    AI智能分析您的体型特点和风格偏好，推荐最适合您的服装搭配方案。
                  </p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md">
                  <h3 className="text-xl font-bold mb-3">社区分享</h3>
                  <p>
                    分享您的搭配到社交平台，获取朋友建议，也可查看时尚达人的穿搭灵感。
                  </p>
                </div>
              </div>
            </div>
          </section>
        )}

        {activeSection === "download" && (
          <section className="py-12 px-4">
            <div className="container mx-auto text-center">
              <h2 className="text-3xl font-bold mb-8">立即下载体验</h2>
              <div className="flex flex-col md:flex-row justify-center gap-8 mb-12">
                <div className="border border-gray-300 rounded-lg p-6 w-full max-w-sm">
                  <h3 className="text-xl font-bold mb-4">iOS版本</h3>
                  <div className="mb-4 flex justify-center">
                    <div className="w-32 h-32 bg-gray-200 rounded-md flex items-center justify-center">
                      <div className="text-gray-500">二维码</div>
                    </div>
                  </div>
                  <p className="mb-4">扫描二维码或点击下方按钮下载iOS版应用</p>
                  <button className="bg-black text-white px-6 py-2 rounded-lg hover:bg-gray-800 transition-colors w-full">
                    App Store 下载
                  </button>
                </div>
                <div className="border border-gray-300 rounded-lg p-6 w-full max-w-sm">
                  <h3 className="text-xl font-bold mb-4">Android版本</h3>
                  <div className="mb-4 flex justify-center">
                    <div className="w-32 h-32 bg-white rounded-md flex items-center justify-center overflow-hidden">
                      <img
                        src="https://a-j.top/qr_android.png"
                        alt="Android版本下载二维码"
                        className="w-full h-full object-contain"
                      />
                    </div>
                  </div>
                  <p className="mb-4">
                    扫描二维码或点击下方按钮下载Android版应用
                  </p>
                  <a
                    href="https://a-j.top/shiyishi.apk"
                    download
                    className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-colors w-full inline-block text-center"
                  >
                    Android 下载
                  </a>
                </div>
              </div>
              <div className="max-w-2xl mx-auto">
                <h3 className="text-xl font-bold mb-4">系统要求</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="border border-gray-300 rounded-lg p-4">
                    <h4 className="font-bold mb-2">iOS版本</h4>
                    <ul className="text-left">
                      <li>iOS 13.0 或更高版本</li>
                      <li>iPhone X 或更新设备</li>
                      <li>需要200MB存储空间</li>
                    </ul>
                  </div>
                  <div className="border border-gray-300 rounded-lg p-4">
                    <h4 className="font-bold mb-2">Android版本</h4>
                    <ul className="text-left">
                      <li>Android 9.0 或更高版本</li>
                      <li>4GB RAM或更高</li>
                      <li>需要180MB存储空间</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {activeSection === "contact" && (
          <section className="py-12 px-4 bg-gray-100">
            <div className="container mx-auto">
              <h2 className="text-3xl font-bold text-center mb-8">联系我们</h2>
              <div className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow-md">
                <div className="mb-8">
                  <h3 className="text-xl font-bold mb-4">客户服务</h3>
                  <p className="mb-2">服务热线：18438615116</p>
                  <p className="mb-2">服务邮箱：hzshiyishi@163.com</p>
                  <p>工作时间：周一至周日 9:00-21:00</p>
                </div>
                <div className="mb-8">
                  <h3 className="text-xl font-bold mb-4">商务合作</h3>
                  <p className="mb-2">合作热线：18438615116</p>
                  <p>商务邮箱：hzshiyishi@163.com</p>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-4">公司地址</h3>
                  <p className="mb-2">
                    浙江省杭州市拱墅区石桥街道康宁街25号一幢5楼509室
                  </p>
                  <p>邮编：310000</p>
                </div>
              </div>
            </div>
          </section>
        )}
      </main>

      {/* 页脚 */}
      <footer className="bg-gray-800 text-white py-8 px-4">
        <div className="container mx-auto">
          <div className="flex flex-col md:flex-row justify-between">
            <div className="mb-6 md:mb-0">
              <h2 className="text-xl font-bold mb-4">TryOnTry 试衣试</h2>
              <p>让时尚购物更简单、更智能、更精准</p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
              <div>
                <h3 className="font-bold mb-3">快速链接</h3>
                <ul>
                  <li className="mb-2">
                    <button
                      onClick={() => setActiveSection("home")}
                      className="hover:text-blue-300"
                    >
                      首页
                    </button>
                  </li>
                  <li className="mb-2">
                    <button
                      onClick={() => setActiveSection("features")}
                      className="hover:text-blue-300"
                    >
                      功能特点
                    </button>
                  </li>
                  <li className="mb-2">
                    <button
                      onClick={() => setActiveSection("download")}
                      className="hover:text-blue-300"
                    >
                      立即下载
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => setActiveSection("contact")}
                      className="hover:text-blue-300"
                    >
                      联系我们
                    </button>
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="font-bold mb-3">法律信息</h3>
                <ul>
                  <li className="mb-2">
                    <a href="#" className="hover:text-blue-300">
                      用户协议
                    </a>
                  </li>
                  <li className="mb-2">
                    <a href="#" className="hover:text-blue-300">
                      隐私政策
                    </a>
                  </li>
                  <li>
                    <a href="#" className="hover:text-blue-300">
                      支付安全
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="font-bold mb-3">关注我们</h3>
                <div className="flex gap-4">
                  <a href="#" className="hover:text-blue-300">
                    微信
                  </a>
                  <a href="#" className="hover:text-blue-300">
                    微博
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-8 pt-6 border-t border-gray-700 text-center md:text-left">
            <p>&copy; 2025 TryOnTry 试衣试 版权所有 豫ICP备2024049295号-1</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
